import type { ReactNode } from 'react'
import { router, usePage } from '@inertiajs/react'
import type { SharedProps } from '../types'

// Compatibility shim: the ported Next.js components import `useAuth` from here.
// Auth now comes from Inertia shared props (Web::BaseController#inertia_share)
// instead of NextAuth + localStorage.
export function useAuth() {
  const { props } = usePage<SharedProps>()
  const user = props.auth?.user ?? null

  return {
    isAuthenticated: !!user,
    user,
    logout: async () => router.delete('/logout'),
    // login/register are handled by the /login and /register Inertia pages now;
    // kept as no-ops for API compatibility with ported components.
    login: async () => ({}),
    register: async () => ({}),
  }
}

// Passthrough — the app shell (AppLayout) provides layout; kept so any leftover
// <AuthProvider> usage still compiles.
export default function AuthProvider({ children }: { children: ReactNode }) {
  return <>{children}</>
}
